<template>
    <div class="locale-changer text-center d-flex justify-content-center align-items-center">
        <font-awesome-icon :icon="['fal', 'earth-americas']" />
        <a
            class="mx-2"
            :class="{active: $i18n.locale === 'en'}"
            @click.stop="updateLocale('en')"
        >
            English
        </a>
        <strong>&bull;</strong>
        <a
            class="ms-2"
            :class="{active: $i18n.locale === 'es'}"
            @click.stop="updateLocale('es')"
        >
            Español
        </a>
    </div>
</template>

<script>
export default {
    name: 'LocaleSelector',
    methods: {
        updateLocale(locale) {
            this.$i18n.locale = locale;
            this.$store.commit('setLocale', locale);
        }
    }
};
</script>

<style lang="scss" scoped>
.locale-changer {
    &.text-white {
        a {
            color: $white;
            text-decoration: none;
            -webkit-transition: color 0.15s ease-in-out 0s;
            transition: color 0.15s ease-in-out 0s;
            &:hover {
                color: $gray-500;
            }
        }
    }

    a {
        cursor: pointer;
        font-weight: 300;
        &.active {
            font-weight: 700;
        }
    }
}
</style>